import React from 'react';
import { createPortal } from 'react-dom';

// Sheet deslizable desde abajo para menús de "más acciones" (⋯ / ⋮).
// Antes este mismo shell (fondo + panel + agarradera) estaba copiado y
// pegado, idéntico, en 5 lugares distintos: Cliente (cliente y equipo),
// Presupuestos, Servicio Técnico y Historial (auditoría UX/UI, punto B1).
// Cada pantalla sigue definiendo sus propios botones — este componente
// solo unifica el contenedor, no la lista de acciones.
// 29-oct-2026: va al body y por encima de las ventanas (abierto desde la ficha de un cliente quedaba debajo,
// pegado abajo de todo y a lo ancho de la pantalla). En la compu es una tarjeta chica centrada.
export default function ActionSheet({ open, onClose, children }) {
    if (!open) return null;
    return createPortal(
        <div className="fixed inset-0 z-[2500] flex items-end md:items-center justify-center md:p-6" onClick={onClose}>
            <div className="absolute inset-0 bg-black/40" />
            <div onClick={e => e.stopPropagation()} role="menu"
                className="relative w-full md:w-auto md:min-w-[320px] md:max-w-sm max-h-[80vh] overflow-y-auto rounded-t-2xl md:rounded-2xl p-2 pb-6 md:pb-2 bg-card shadow-2xl border-t md:border border-black/[0.08] dark:border-white/[0.08]">
                <div className="w-10 h-1 rounded-full mx-auto mb-2 bg-chip md:hidden" />
                {children}
            </div>
        </div>,
        document.body,
    );
}
